import { create } from "zustand";

export const useAlert = create((set) => ({
    alert: null,
    props: {},
    setProps: (props) => set({props}),
    updateProps: (props) => set(prev => ({props: {...prev.props, ...props}})),
    show: (item) => set({alert: item}),
    hide: () => set({alert: null}),
    asyncAlert: async ({title = '', message = '', buttons = []}) => {
        return new Promise((resolve, reject) => {
            set({
                alert: {
                    title,
                    message,
                    type: 'confirm',
                    buttons : buttons.map(({title, type, resolve:resolveValue, onPress = () => {}}) => ({
                        title,
                        type,
                        onPress: () => {
                            onPress();
                            resolve(resolveValue);
                            set({alert: null});
                        }
                    })),
                }
            })
        })
    },
    asyncBoolean: async ({title = '', message = ''}) => {
        return new Promise((resolve, reject) => {
            set({
                alert: {
                    title,
                    message,
                    type: 'confirm',
                    buttons: [
                        {title: 'buttons.yes', type: 'info', onPress: () => {resolve(true);set({alert: null})}},
                        {title: 'buttons.no', type: 'default', onPress: () => {resolve(false);set({alert: null})}}
                    ]
                }
            })
        })
    }
}));